var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SrInput',_vm._g(_vm._b({},'SrInput',_vm.attrs,false),_vm.$listeners)),_c('VDivider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }